export enum MissionStep {
  FLIGHT_DETAILS = 'flight_details',
  FLIGHT_PARAMETERS = 'flight_parameters',
  DRONE_SELECTION = 'drone_selection',
}

export const MISSION_STEP_ORDER: MissionStep[] = [
  MissionStep.FLIGHT_DETAILS,
  MissionStep.FLIGHT_PARAMETERS,
  MissionStep.DRONE_SELECTION,
];

export const MISSION_STEP_TITLES: Record<MissionStep, string> = {
  [MissionStep.FLIGHT_DETAILS]: 'STEP 1: FLIGHT DETAILS',
  [MissionStep.FLIGHT_PARAMETERS]: 'STEP 2: FLIGHT PARAMETERS',
  [MissionStep.DRONE_SELECTION]: 'STEP 3: DRONE SELECTION',
};
